<route>
{
  "meta": {
    "permission": [
      "expenses.view_account"
    ]
  }
}
</route>

<template>
  <div>
    <dialaccount v-model="dialog" :to-edit="toEdit" @done="reload = true" />
    <i-table
      :title="$tc('account', 2)"
      :headers="headers"
      app="expenses.account"
      api="expense.account"
      :reload.sync="reload"
      @click:create="open()"
      @click:edit="open($event)"
    >
    </i-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import dialaccount from '../../components/expenseAccount/modal.vue'
export default {
  components: {
    dialaccount
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text:
            this.accountBtn.delete || this.accountBtn.edit
              ? this.$t('action')
              : '',
          value: this.accountBtn.delete || this.accountBtn.edit ? 'actions' : ''
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    accountBtn() {
      return {
        delete:
          this.getPermissions([`expenses.delete_account`]) || this.isAdmin,
        edit: this.getPermissions([`expenses.change_account`]) || this.isAdmin
      }
    }
  },
  data() {
    return {
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
